"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6552],{

/***/ 36552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15072);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &.breadcrumb {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    min-height: 40px;\n    li {\n      font-size: 16pt;\n      min-height: 30px;\n      &.more-cate {\n        a {\n          color: var(--primary-color);\n        }\n      }\n      color: var(--primary-color);\n    }\n    li + li {\n      &:before {\n        content: '>';\n        padding: 0 10px;\n        color: var(--primary-color);\n      }\n    }\n    @media (max-width: 767px) {\n      justify-content: center;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function WidgetBreadcrumb(param) {
    var article = param.article;
    var ref, ref1, ref2, ref3;
    // console.log('article', article);
    var categoryName = ((ref = article.section) === null || ref === void 0 ? void 0 : ref.th) === "ข่าวล่าสุด" ? "Latest News" : (ref1 = article.section) === null || ref1 === void 0 ? void 0 : ref1.th;
    var subCategoryName = article.subCategory ? article.subCategory.th : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WidgetWrapper, {
        className: "breadcrumb",
        style: {
            filter: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : ""
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                    href: "/",
                    children: "หน้าแรก"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                className: "more-cate",
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        href: "".concat(categoryName ? "/category/".concat(article === null || article === void 0 ? void 0 : (ref2 = article.section) === null || ref2 === void 0 ? void 0 : ref2.en) : ""),
                        children: categoryName
                    })
                ]
            }),
            subCategoryName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                className: "more-cate",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        href: "".concat("/category/".concat(article === null || article === void 0 ? void 0 : (ref3 = article.section) === null || ref3 === void 0 ? void 0 : ref3.en, "/").concat(article.subCategory.en)),
                        children: subCategoryName
                    }),
                    " "
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (WidgetBreadcrumb);
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].ul(_templateObject());


/***/ })

}]);